import {
  Box,
  ButtonGroup,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
  useTheme,
} from '@mui/material';
import { ErrorButton, GreyButton, SuccessButton } from 'components/atoms';
import React from 'react';
import { IconType } from 'react-icons';
import { IoMdClose } from 'react-icons/io';
import { IoWarning } from 'react-icons/io5';

import { InfoSimpleModalProps } from './types';

export const InfoSimpleModal = ({
  icon,
  onClose,
  open,
  onSubmit,
  oneButton = false,
  successButton = true,
  text,
  title,
  titleIcon = false,
}: InfoSimpleModalProps) => {
  const ButtonIcon = icon as IconType;
  const theme = useTheme();
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle
        sx={{
          // @ts-ignore
          backgroundColor: `${theme.palette.grey.light}`,
          display: 'flex',
          justifyContent: 'space-between',
          p: 8,
        }}
      >
        <Box sx={{ display: 'flex' }}>
          {titleIcon ? (
            <IoWarning
              // @ts-ignore
              color={theme.palette.red.main}
              style={{ marginTop: 'auto', marginBottom: 'auto' }}
            />
          ) : null}
          <Typography
            fontSize={'24px'}
            fontWeight={700}
            component="div"
            sx={{ marginTop: 'auto', marginBottom: 'auto' }}
          >
            {title}
          </Typography>
        </Box>
        <IconButton aria-label="close" onClick={onClose} sx={{ marginRight: 5 }}>
          <IoMdClose />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        {text.map((t, i) => (
          <Typography gutterBottom key={`text-${i}`}>
            {t}
          </Typography>
        ))}
      </DialogContent>
      <DialogActions sx={{ margin: 'auto' }}>
        <ButtonGroup size="large" variant="contained">
          <GreyButton
            aria-label="close"
            onClick={onClose}
            sx={{ paddingLeft: '48px', paddingRight: '48px' }}
          >
            <IoMdClose style={{ fontSize: '2rem' }} />
          </GreyButton>
          {oneButton ? null : successButton ? (
            <SuccessButton
              aria-label="close"
              data-testid="modal-confirm"
              onClick={onSubmit}
              sx={{ paddingLeft: '48px', paddingRight: '48px' }}
            >
              <ButtonIcon style={{ fontSize: '2rem' }} />
            </SuccessButton>
          ) : (
            <ErrorButton
              aria-label="close"
              data-testid="modal-confirm"
              onClick={onSubmit}
              sx={{ paddingLeft: '48px', paddingRight: '48px' }}
            >
              <ButtonIcon style={{ fontSize: '2rem' }} />
            </ErrorButton>
          )}
        </ButtonGroup>
      </DialogActions>
    </Dialog>
  );
};
